import { createGlobalStyle } from 'styled-components';
import img from './lain1.jpg';

const Answer_ALoaderStyle = createGlobalStyle`

body {
    background: url(${img}) no-repeat center center fixed;
    background-size: cover;
    background-color: #0a0a0a;
    font-family: Arial, sans-serif;
    font-size: 16px;
    color: #ff69b4;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    overflow-x: hidden;
}

/* Main Container */
.answer-main {
    min-height: calc(100vh - 140px);
    padding: 2rem 1rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.answer-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
}

/* Answer Card */
.answer-card {
    padding: 2rem;
    background: linear-gradient(135deg, rgba(20, 10, 20, 0.75) 0%, rgba(40, 20, 40, 0.75) 100%);
    border: 2px solid #ff1493;
    border-radius: 10px;
    box-shadow: 0 0 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
    animation: shadow-move-pink 4s infinite alternate;
    backdrop-filter: blur(5px);
    position: relative;
    overflow: hidden;
}

.answer-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(255, 20, 147, 0.03) 2px,
        rgba(255, 20, 147, 0.03) 4px
    );
    animation: scan 10s linear infinite;
    pointer-events: none;
}

@keyframes scan {
    0% { transform: translateY(0); }
    100% { transform: translateY(50%); }
}

@keyframes shadow-move-pink {
    0% {
        box-shadow: 0 0 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(255, 105, 180, 0.4), 0 0 20px rgba(255, 20, 147, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(255, 105, 180, 0.4), 0 0 20px rgba(255, 20, 147, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(255, 20, 147, 0.4), 0 0 20px rgba(255, 105, 180, 0.4);
    }
}

/* Loader */
.loader-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

.loader-wrapper::before {
    content: "{";
    color: #ff69b4;
    font-family: Consolas, Menlo, Monaco, monospace;
    font-weight: bold;
    font-size: 78px;
    text-shadow: 0 0 20px rgba(255, 20, 147, 0.8);
    animation: pulse 0.4s alternate infinite ease-in-out;
    margin-right: 1rem;
}

.loader-wrapper::after {
    content: "}";
    color: #ff69b4;
    font-family: Consolas, Menlo, Monaco, monospace;
    font-weight: bold;
    font-size: 78px;
    text-shadow: 0 0 20px rgba(255, 20, 147, 0.8);
    animation: pulse 0.4s 0.3s alternate infinite ease-in-out;
    margin-left: 1rem;
}

.loader-text {
    color: #ff69b4;
    font-family: Arial, sans-serif;
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    text-shadow: 0 0 20px rgba(255, 20, 147, 0.8);
    margin: 0;
}

@keyframes pulse {
    to {
        transform: scale(0.8);
        opacity: 0.5;
    }
}

/* Content Styles */
p {
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    margin: 1.5rem 0;
    text-align: center;
    text-shadow: 0 0 10px rgba(255, 105, 180, 0.6);
    position: relative;
    z-index: 1;
}

label {
    display: block;
    margin: 20px 0;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(255, 105, 180, 0.6);
    text-align: center;
    position: relative;
    z-index: 1;
}

textarea {
    width: 100%;
    margin: 10px 0;
    padding: 10px;
    border-radius: 5px;
    border: 2px solid #ff1493;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0 0 10px rgba(255, 20, 147, 0.3);
    font-size: 16px;
    color: #ffffff;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
}

/* Answer Display Sections */
#userAnswer, #correctAnswer, #aiSuggestions {
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid #ff1493;
    border-radius: 5px;
    padding: 1.5rem;
    margin: 1rem 0;
    position: relative;
    z-index: 1;
}

p2 {
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    display: block;
    line-height: 1.6;
}

xmp {
    color: #ffffff;
    background: rgba(0, 0, 0, 0.6);
    padding: 1rem;
    border-radius: 5px;
    border: 1px solid #ff1493;
    margin: 0.5rem 0;
    overflow-x: auto;
}

/* Buttons */
.reveal-button {
    background: linear-gradient(135deg, #ff1493 0%, #ff69b4 100%);
    border: 2px solid #ff69b4;
    border-radius: 5px;
    color: #ffffff;
    padding: 12px 24px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin: 1rem 0.5rem;
    cursor: pointer;
    box-shadow: 0 0 20px rgba(255, 20, 147, 0.4);
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: relative;
    z-index: 1;
}

.reveal-button:hover:not(:disabled) {
    box-shadow: 0 0 40px rgba(255, 20, 147, 0.8), inset 0 0 20px rgba(255, 20, 147, 0.3);
    animation: electric 0.8s infinite;
    background: linear-gradient(135deg, #ff69b4 0%, #ff1493 100%);
}

.reveal-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #666;
}

/* Nav Menu Hover Effects */
nav ul li a, nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}

nav ul li a:hover, nav ul li button:hover {
    color: #ff1493;
    text-shadow: 1px 1px 2px #ff1493, 0 0 1em #ff1493, 0 0 0.2em #ff69b4;
    transition: text-shadow 0.3s ease;
    animation: electric 0.8s infinite;
}

nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
    margin-top: auto;
    height: 60px;
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
} */

/* Animations */
@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        filter: drop-shadow(0 0 5px currentColor);
    }
    50% {
        text-shadow: 0 0 10px currentColor, 0 0 20px currentColor;
        filter: drop-shadow(0 0 15px currentColor);
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        filter: drop-shadow(0 0 5px currentColor);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .answer-main {
        padding: 1rem 0.75rem;
    }

    .answer-card {
        padding: 1.5rem;
    }

    p {
        font-size: 18px;
    }

    .reveal-button {
        width: 100%;
        margin: 0.5rem 0;
    }
}
`;

export default Answer_ALoaderStyle;
